






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import BookmarkAdd from '@/components/bookmark/bookmark-add.vue';
import MainMenuMobile from '@/views/layout/navigation/main-menu-mobile.vue';
import ReportTabsMixin from '@/views/reports/views/mixins/report-tabs-mixin';
import MainMenuReportTabsMobileItem from '@/views/layout/navigation/grouping/main-menu-report-tabs-mobile-item.vue';
import BookmarkAddMenu from '@/components/bookmark/bookmark-add-menu.vue';

@Component
export default class ReportTabsActions extends Vue {
  @Prop() 
  item: any;

  @Prop() 
  hasBookmark: boolean;

  @Emit('open-bookmark') 
  onOpenBookmark() {}

  menu: boolean = false;

  get menuList(): Bemob.ListItem[] {
    const addToBookmark: Bemob.ListItem = {
      key: 'addToBookmark',
      title: 'Add Bookmark',
      iconAppend: this.hasBookmark 
        ? 'fas fa-star'
        : 'far fa-star',
      iconColor: this.hasBookmark 
        ? this.$colors.sunglow
        : null,
      click: () => this.onOpenBookmark()
    }

    const shareReport: Bemob.ListItem = {
      key: 'shareReport',
      title: 'Share Report',
      iconAppend: 'far fa-share-square'
    }

    return [ addToBookmark/*, shareReport */ ]; 
  }

  handleChevronClick() {
    this.menu = !this.menu;
  }
}
